// src/app/modules/Dashboard/_redux/dashboard/Crud.billing.js

import axios from "axios";
import config from "../../../../../config";

// ── BILLING PLANS ──────────────────────────────────────────────────────────

export function getBillingPlans(org_type) {
  const params = new URLSearchParams();
  if (org_type) params.append('org_type', org_type);
  return axios.get(`${config.URL}billing/plans?${params.toString()}`);
}

// ── SUBSCRIPTION ───────────────────────────────────────────────────────────

export function getSubscription(organization_id) {
  return axios.get(`${config.URL}billing/organizations/${organization_id}/subscription`);
}

export function initializeSubscription(organization_id, data) {
  return axios.post(`${config.URL}billing/organizations/${organization_id}/subscription/initialize`, data);
}

export function startTrial(organization_id, data) {
  return axios.post(`${config.URL}billing/organizations/${organization_id}/subscription/trial`, data);
}

export function cancelSubscription(organization_id) {
  return axios.delete(`${config.URL}billing/organizations/${organization_id}/subscription`);
}

/**
 * Upgrade or downgrade plan mid-cycle.
 * Upgrades charge the prorated difference immediately.
 * Downgrades bank a credit for the next invoice.
 * PATCH /billing/organizations/:id/subscription/plan
 */
export function changePlan(organization_id, data) {
  return axios.patch(`${config.URL}billing/organizations/${organization_id}/subscription/plan`, data);
}

/**
 * Apply a promo code to the active subscription.
 * Credit is applied automatically on the next invoice.
 * POST /billing/organizations/:id/subscription/promo
 */
export function applyPromoCode(organization_id, data) {
  return axios.post(`${config.URL}billing/organizations/${organization_id}/subscription/promo`, data);
}

// ── INVOICES ───────────────────────────────────────────────────────────────

export function getInvoices(organization_id, params = {}) {
  const query = new URLSearchParams();
  if (params.status) query.append('status', params.status);
  if (params.page)   query.append('page',   params.page);
  if (params.limit)  query.append('limit',  params.limit);
  return axios.get(`${config.URL}billing/organizations/${organization_id}/invoices?${query.toString()}`);
}

export function getInvoice(organization_id, invoice_id) {
  return axios.get(`${config.URL}billing/organizations/${organization_id}/invoices/${invoice_id}`);
}

export function payInvoice(organization_id, invoice_id) {
  return axios.post(`${config.URL}billing/organizations/${organization_id}/invoices/${invoice_id}/pay`);
}

/**
 * FIX: was (organizationId, data) — invoice_id was in the body.
 * Now invoice_id is a URL param, body only carries optional callback_url.
 * Also fixed: was using ${URL} (window.URL) instead of ${config.URL}.
 */
export function createInvoicePaymentLink(organization_id, invoice_id, body = {}) {
  return axios.post(
    `${config.URL}billing/organizations/${organization_id}/invoices/${invoice_id}/payment-link`,
    body
  );
}

// ── PAYMENT METHODS ────────────────────────────────────────────────────────

export function getPaymentMethods(organization_id) {
  return axios.get(`${config.URL}billing/organizations/${organization_id}/payment-methods`);
}

export function setDefaultPaymentMethod(organization_id, payment_method_id) {
  return axios.patch(`${config.URL}billing/organizations/${organization_id}/payment-methods/${payment_method_id}/default`);
}

export function removePaymentMethod(organization_id, payment_method_id) {
  return axios.delete(`${config.URL}billing/organizations/${organization_id}/payment-methods/${payment_method_id}`);
}